import { render } from "./GuestDetails.vue?vue&type=template&id=3bb7340e&scoped=true"
import script from "./GuestDetails.vue?vue&type=script&lang=js"
export * from "./GuestDetails.vue?vue&type=script&lang=js"

import "./GuestDetails.vue?vue&type=style&index=0&id=3bb7340e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb7340e"]])

export default __exports__